import axios from "axios";
const { API_BACKEND_HOST } = process.env;
const responseFormat: { error: string, data: any } = { error: "", data: null };

export const newCommittee = async (request: any) => {
  const languageId = localStorage.getItem("i18nextLng");
  try {
    const response = await axios.post(
      `${API_BACKEND_HOST}${languageId}/v1/Committee`,
      request
    );
    responseFormat.data = response;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }: any) {
    responseFormat.error =
      response.data.errors.length > 0 ? response.data.errors.join(", ") : "Erro ao tentar criar o comitê";
    return responseFormat;
  }
};

export const updateCommittee = async (id: any, request: any) => {
  const languageId = localStorage.getItem("i18nextLng");
  try {
    const response = await axios.put(
      `${API_BACKEND_HOST}${languageId}/v1/Committee/${id}`,
      request
    );
    responseFormat.data = response;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }: any) {
    responseFormat.error =
      response.data.errors || "Erro ao tentar editar o comitê";
    return responseFormat;
  }
};

export const getAllCommittees = async ({
  committeeName,
  committeeStatus,
  frequenciaId,
}: any) => {
  try {
    const languageId = localStorage.getItem("i18nextLng");

    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/Committee`,
      {
        params: {
          pageSize: 999999,
          typeOrder: null,
          ...(committeeName && { committeeName }),
          ...(typeof committeeStatus === 'boolean' && { committeeStatus }),
          ...(frequenciaId && { frequenciaId }),
        },
      }
    );
    responseFormat.data = data.items;
    responseFormat.error = "";

    return responseFormat;
  } catch ({ response }: any) {
    responseFormat.error = "async";
    return responseFormat;
  }
};

export const getCommittees = async (params: any) => {
  try {
    const languageId = localStorage.getItem("i18nextLng");

    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/Committee`,
      {
        params,
      }
    );

    responseFormat.data = data;
    responseFormat.error = "";

    return responseFormat;
  } catch ({ response }: any) {
    responseFormat.error = "async";
    return responseFormat;
  }
};

export const getAllCommitteesFromAllPackages = async () => {
  try {
    const languageId = localStorage.getItem("i18nextLng");

    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/Committee/FromAllPackages`,
    );

    responseFormat.data = data;
    responseFormat.error = "";

    return responseFormat;
  } catch ({ response }: any) {
    responseFormat.error = response.data.errors.length > 0 ? response.data.errors.join(', ') : "async";
    return responseFormat;
  }
};

export const getAllCommitteesMettings = async () => {
  try {
    const languageId = localStorage.getItem("i18nextLng");

    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/Committee/committee-contains-meets`
    );
    responseFormat.data = data;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }: any) {
    responseFormat.error = "async";
    return responseFormat;
  }
};

export const getAllSlotCommittees = async ({
  committeeName,
  committeeStatus,
  frequenciaId,
}: any) => {
  try {
    const languageId = localStorage.getItem("i18nextLng");

    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/Committee/slot/GetAllCommittee`,
      {
        params: {
          pageSize: 999999,
          typeOrder: null,
          committeeName,
          committeeStatus,
          frequenciaId,
        },
      }
    );
    responseFormat.data = data.items;
    responseFormat.error = "";

    return responseFormat;
  } catch ({ response }: any) {
    responseFormat.error = "async";
    return responseFormat;
  }
};

export const getAllCommitteesByLanguageId = async (languageId: any) => {
  try {
    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/Committee`,
      {
        params: {
          pageSize: 999999,
          typeOrder: null,
        },
      }
    );
    responseFormat.data = data.items;
    responseFormat.error = "";

    return responseFormat;
  } catch ({ response }: any) {
    responseFormat.error = "async";
    return responseFormat;
  }
};

export const getCommitteeById = async (id: any) => {
  try {
    const languageId = localStorage.getItem("i18nextLng");
    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/Committee/${id}`
    );
    responseFormat.data = data;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }: any) {
    responseFormat.error = response.data.errors[0] || " ";
    return responseFormat;
  }
};

export const getCommitteeSummaryById = async (id: any) => {
  try {
    const languageId = localStorage.getItem("i18nextLng");
    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/Committee/GetPersons/${id}`
    );
    responseFormat.data = data;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }: any) {
    responseFormat.error = "async";
    return responseFormat;
  }
};

export const disabledCommittee = async ({ id, disabled }: any) => {
  try {
    const languageId = localStorage.getItem("i18nextLng");
    const { data } = await axios.patch(
      `${API_BACKEND_HOST}${languageId}/v1/Committee/${id}/${disabled}`
    );
    responseFormat.data = data;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }: any) {
    const responseError = response.data.errors[0] || " ";

    responseFormat.error = responseError;
    return responseFormat;
  }
};

export const updateCommitteeImportance = async ({ id, direction }: any) => {
  try {
    const languageId = localStorage.getItem("i18nextLng");
    const { data } = await axios.put(
      `${API_BACKEND_HOST}${languageId}/v1/Committee/updateImportance`,
      {
        id,
        direction,
      }
    );

    return data;
  } catch ({ response }: any) {
    const responseError = response.data.errors[0] || " ";

    responseFormat.error = responseError;
    return responseFormat;
  }
};
